import {NgModule} from '@angular/core';

import {PrescriptionRealisePharmacieDetailTableComponent} from './prescription-realise-pharmacie-detail-table.component';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@shared/shared.module';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
    ],
  exports: [PrescriptionRealisePharmacieDetailTableComponent],
  declarations: [PrescriptionRealisePharmacieDetailTableComponent],
  providers: [],
})
export class PrescriptionRealisePharmacieDetailTableModule {
}
